import { rxapi, api } from '../api';
import { processQuery } from './paging';
import type {
    ColumnTemplate,
    ColumnTemplatePatch,
    ColumnTemplateRecord,
    ConcreteColumnTemplate,
} from '@thinkalpha/ui-types/contracts/column-template';
import type { ResourceQuery, ResourceQueryResponseWithMeta } from '@thinkalpha/ui-types/contracts/resource-query';
import type { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

export const getColumnTemplatesQuery = async (
    query: ResourceQuery,
): Promise<ResourceQueryResponseWithMeta<ConcreteColumnTemplate> | ConcreteColumnTemplate[]> => {
    return (await api.get(`/column-templates/query${processQuery(query)}`)).data;
};
export const getColumnTemplates = async (key = 'ticker'): Promise<ConcreteColumnTemplate[]> => {
    return (await api.get(`/column-templates`, { params: { key } })).data;
};

export function getColumnTemplateRecords(key = 'ticker'): Observable<ColumnTemplateRecord[]> {
    return rxapi.get<ColumnTemplateRecord[]>('/column-templates', { params: { key } }).pipe(map((x) => x.data));
}

export function getDefaultColumnTemplate(key: string): Observable<ConcreteColumnTemplate> {
    return rxapi.get<ConcreteColumnTemplate>(`/column-templates/default`, { params: { key } }).pipe(map((x) => x.data));
}

export function getColumnTemplate(id: string): Observable<ConcreteColumnTemplate> {
    return rxapi.get<ConcreteColumnTemplate>(`/column-templates/${id}`).pipe(map((x) => x.data));
}

export function createColumnTemplateLegacy(columnTemplate: ColumnTemplate): Observable<ConcreteColumnTemplate> {
    return rxapi.post<ConcreteColumnTemplate>('/column-templates', columnTemplate).pipe(map((x) => x.data));
}

export async function createColumnTemplate(columnTemplate: ColumnTemplate): Promise<ConcreteColumnTemplate> {
    return (await api.post<ConcreteColumnTemplate>('/column-templates', columnTemplate)).data;
}

export function updateColumnTemplateLegacy(id: string, patch: ColumnTemplatePatch): Observable<ConcreteColumnTemplate> {
    return rxapi.patch<ConcreteColumnTemplate>(`/column-templates/${id}`, patch).pipe(map((x) => x.data));
}

export async function updateColumnTemplate(id: string, patch: ColumnTemplatePatch): Promise<ConcreteColumnTemplate> {
    return (await api.patch<ConcreteColumnTemplate>(`/column-templates/${id}`, patch)).data;
}

export async function deleteColumnTemplate(id: string): Promise<void> {
    return (await api.delete(`/column-templates/${id}`)).data;
}

export function isPermissionedColumnTemplate(
    columnTemplate: ConcreteColumnTemplate | ColumnTemplate,
): columnTemplate is ConcreteColumnTemplate {
    return !!(columnTemplate as ConcreteColumnTemplate).permissions;
}
